import Close from '@mui/icons-material/Close';
import { Banner } from '@src/common/components/Banner';
import { Box } from '@src/common/components/Box';
import { IconButton } from '@src/common/components/IconButton';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';

interface Props {
  severity: 'info' | 'success' | 'error' | 'warning' | 'other';
  style?: object;
  defaultOpen?: boolean;
  onClose?: () => void;
}

export const ClosableBanner = ({
  children,
  severity,
  style = {},
  onClose,
}: PropsWithChildren<Props>) => {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };
  return (
    <Banner
      severity={severity}
      style={{
        position: 'relative',
        paddingRight: theme.spacing[9],
        ...style,
      }}
    >
      <IconButton className={iconBtnStyle} onClick={handleClose}>
        <Close fontSize="small" />
      </IconButton>
      <Box>{children}</Box>
    </Banner>
  );
};

const iconBtnStyle = css({
  position: 'absolute',
  top: '8px',
  right: '8px',
  width: '28px',
  height: '28px',
});
